/**
* MantencionPage component
* @returns <MantencionPage />
*/
import ItemDetailMantencion from "../components/ItemDetailMantencion";
import Breadcrumbs from "../components/Breadcrumbs";
import { AnimatePresence } from "framer-motion";

import { useGetMaintenancePlanByIdQuery, useGetAllMaintenancePlansQuery } from "../redux/apiSlice";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../components/Loader";

const MantencionPage = () => {
    // Get the location to use in the Breadcrumbs
    const location = useLocation();

    // Get the maintenance ID from the route parameters
    const { mantencionId } = useParams();

    // Perform the query to get the maintenance plan by ID
    const {
        data: maintenancePlanById,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetMaintenancePlanByIdQuery(mantencionId)

    const {
        data: maintenancePlan,
    } = useGetAllMaintenancePlansQuery()

    // Configure the Breadcrumbs properties
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: "..",
                label: location.pathname.split("/")[1]
            },
            {
                link: `../${location.pathname.split("/")[2]}`,
                label: maintenancePlanById?.title
            }
        ],

        btnConfig: {
            tag: "link",
            text: "Volver a todos los servicios",
            color: "black",
            extraClass: "with-icon",
            hasIcon: true,
            url: "/mantenciones"
        }
    }

    // This content is the same as the modal
    const drawer = {
        title: "La mantención incluye",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, atque.",
        isOpen: true
    }

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <ItemDetailMantencion item={maintenancePlanById} doc={maintenancePlan} />
                </>
            )}
            {isError && <p>Hubo un error</p>}
            {/* <Drawer data={drawer} /> */}
        </>
    )
}

export default MantencionPage